import ToolTip from "../../ToolTip/ToolTip";

const handleAssign = (params) => {
  return (
    <ToolTip
      content={params.row.brand_description || "N/A"}
      expand={params.row.brand_description}
    />
  );
};

export const Brand_Table_Head = [
  {
    field: "sl_no",
    headerName: "Sl No",
  },
  {
    field: "brand_name",
    headerName: "Name",
    width: 200,
  },
  {
    field: "brand_description",
    headerName: "Description",
    width: 200,
    renderCell: handleAssign,
  },
  {
    field: "brand_created_at",
    headerName: "Created At",
    width: 200,
  },
];
